export default __webpack_public_path__ + "static/bulldozer-bee-9c008f5625efe75a45b0c2f71401ce3a.png";